import React from 'react';
import { Box } from '../Box';

export interface Divisor {
  type: 'line' | 'space';
}

export const Divisor = ({ type }: Divisor) =>
  type === 'line' ? (
    <Box borderTopWidth={1} borderTopColor={'gray60'} width={'100%'} />
  ) : (
    <Box height={16} />
  );
